const VIDEOS = {
    SYNDIE: "https://steria.sharepoint.com/sites/BlockchainBoulevard/Shared%20Documents/General/Video%20and%20PPT/1.%20Loan%20Syndication/LoanSyndication.mp4",
    
    Digicoin: "https://steria.sharepoint.com/sites/BlockchainBoulevard/Shared%20Documents/General/Video%20and%20PPT/3.%20Digicoin/Digicoin%20Demo_19_June_2020.mp4",
    
    KFW: "https://steria.sharepoint.com/sites/BlockchainBoulevard/Shared%20Documents/General/Video%20and%20PPT/4.%20KFW/Pump_Monitoring_video.mp4",

};

const DECK = {
    SYNDIE: "https://steria.sharepoint.com/sites/BlockchainBoulevard/Shared%20Documents/General/Video%20and%20PPT/1.%20Loan%20Syndication/Loan_Syndication_1.4.pdf",
    Customs: "https://steria.sharepoint.com/sites/BlockchainBoulevard/Shared%20Documents/General/Video%20and%20PPT/2.%20French%20Custom/FrenchCustom1.pdf",
    Digicoin: "https://steria.sharepoint.com/sites/BlockchainBoulevard/_layouts/15/Doc.aspx?OR=teams&action=edit&sourcedoc={CC01B7ED-CCE1-46ED-900D-F1B43FF0865F}",
    Drones: "https://steria.sharepoint.com/sites/BlockchainBoulevard/Shared%20Documents/General/Video%20and%20PPT/6.%20French%20Drones/FrenchDrones.pdf",

}

const FUNCTION_URL = 'https://blvdfunctions.azurewebsites.net/api/commonOps?code=gpty3NvDE9ZJLSaDVUNi6oSpK1ysKckCcarP2bO6B2UuS/lczcZR4A=='
// const FUNCTION_URL = 'http://localhost:7071/api/commonOps?code=gpty3NvDE9ZJLSaDVUNi6oSpK1ysKckCcarP2bO6B2UuS/lczcZR4A=='

module.exports = {
    VIDEOS,
    DECK,
    FUNCTION_URL
};